export class YoutubeVideo {

    constructor() {
        $(function() {

            if (window.YoutubeVideo.isMobileDevice()) {
                return;
            }

            // Load the IFrame Player API code asynchronously.
            let tag = document.createElement('script');
            tag.src = "https://www.youtube.com/player_api";
            let firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubeIframeAPIReady = function() {
                window.player = new window.YT.Player('ytplayer', {
                    videoId: $("#ytplayer.trailer-player").attr('data-video-id'),
                    playerVars: {
                        rel: 0,
                        controls: 0,
                        disablekb: 1,
                        showinfo: 0,        // Hide the video title
                        modestbranding: 1,  // Hide the Youtube Logo
                        fs: 0,              // Hide the full screen button
                        cc_load_policy: 0,  // Hide closed captions
                        iv_load_policy: 3,  // Hide the Video Annotations
                        autohide: 0         // Hide video controls when playing
                    },
                    events: {
                        'onStateChange': window.YoutubeVideo.onPlayerStateChange,
                        'onReady': window.YoutubeVideo.onPlayerReady
                    }
                });
            };
        });
    }

    onPlayerReady(event)
    {
        event.target.mute();
        event.target.playVideo();
    }

    onPlayerStateChange(event)
    {
        if (event.data === window.YT.PlayerState.BUFFERING) {
            $('#ytplayer').removeClass('d-none');
        }

        if (event.data === window.YT.PlayerState.ENDED) {
            event.target.seekTo(0);
            event.target.pauseVideo();
            $('#ytplayer').addClass('d-none');
        }
    }

    isMobileDevice()
    {
        let isMobile = false;
        if( $( window ).width() < 768 ) {
            isMobile = true;
        } /* else if ("maxTouchPoints" in navigator) {
            isMobile = navigator.maxTouchPoints > 0;
        } else if ("msMaxTouchPoints" in navigator) {
            isMobile = navigator.msMaxTouchPoints > 0;
        } else {
            let mQ = window.matchMedia && matchMedia("(pointer:coarse)");
            if (mQ && mQ.media === "(pointer:coarse)") {
                isMobile = !!mQ.matches;
            } else if ('orientation' in window) {
                isMobile = true; // deprecated, but good fallback
            } else {
                // Only as a last resort, fall back to user agent sniffing
                let UA = navigator.userAgent;
                isMobile = (
                    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
                );
            }
        }
        */

        return isMobile;
    }
}







// WEBPACK FOOTER //
// ./resources/js/MrMovie/YoutubeVideo.js